/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Get_3Inputs */

const en_cp_lead_get_3 = /** @type {(inputs: Cp_Lead_Get_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2-hour build-night kit: script, slides, PRD template, poster`)
};

const id_cp_lead_get_3 = /** @type {(inputs: Cp_Lead_Get_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kit build night 2 jam: naskah, slide, template PRD, poster`)
};

/**
* | output |
* | --- |
* | "2-hour build-night kit: script, slides, PRD template, poster" |
*
* @param {Cp_Lead_Get_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_get_3 = /** @type {((inputs?: Cp_Lead_Get_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Get_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_get_3(inputs)
	return en_cp_lead_get_3(inputs)
});